import { useState } from 'react';
import { onboardUser } from '../utils/apiCalls';
import Modal from './Modal';

export default function OnboardAdmin({ isOpen, onClose, clinicId, token, onSuccess }) {
    const initialFormData = { full_name: '', email: '', role: 'admin' }
    const [formData, setFormData] = useState(initialFormData);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');


    //  handle change for form fields
    const handleChange = (event) => {
        let { name, value } = event.target;

        setFormData({ ...formData, [name]:value });
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    // Validate phone/email 
    const validateField = (name, value) => {
        setError('');

        if (!value) {
            switch (name) {
                case 'full_name':
                    setError('Please fill out Name');
                    break;
                case 'email':
                    setError('Please enter a valid email address');
                    break;
                default:
                    setError('');
                    break;
            }
        } else {
            switch (name) {
                case 'email':
                    if (!emailRegex.test(value)) {
                        setError('Please enter a valid email address');
                    }
                    break;
                default:
                    setError('');
                    break; 
            }
        }
    };

    const handleBlur = (event) => {
        const { name, value } = event.target;
        validateField(name, value);
    }

    const handleValidate = () => {
        // let valid = true;
        setError('');

        if (!formData.full_name) {
            setError('Name is required');
            return false;
        }
        else if (!formData.email ||!emailRegex.test(formData.email)) {
            setError('Valid email address is required');
            return false;
        }
        return true;
        
    }

    const handleSubmit = async (event) => {
    event.preventDefault();
    if (!handleValidate()) return;

        setLoading(true);
        setError('');

        const payload = { full_name: formData.full_name, location_id: null, clinic_id: clinicId, email: formData.email, role: formData.role};
        console.log('Onboard payload:', payload);

        try {
            const result = await onboardUser(payload, token );

            if (!result?.username) {
                throw new Error('User record was not created');
            }
            setFormData(initialFormData);
            onClose();
            if (onSuccess) onSuccess();
            } catch (error) {
                setError(error.message || 'Failed to onboard user');
            } finally {
                setLoading(false);
            }
        }

    if (!isOpen) return null;

    return (
        <Modal >
            <h2 className="text-xl font-bold text-docpgrPurple mb-4">
                onboard clinic admin
            </h2>

            {error && <p className="text-red-500 mb-2">{error}</p>}

            <form onSubmit={handleSubmit} className="space-y-4">
                {/* name  */}
                <div>
                    <input type='text' name='full_name' placeholder='full name' value={formData.full_name} onChange={handleChange} onBlur={handleBlur} required className='w-full border rounded p-2' />
                </div>
                {/* email  */}
                <div>
                    <input type='email' name='email' placeholder='email address' value={formData.email} onChange={handleChange} onBlur={handleBlur} required className='w-full border rounded p-2' />
                </div>

                <div className='flex justify-end gap-2'>
                    <button type='button' onClick={onClose} className='mt-4 px-4 py-2 rounded-lg text-slate-600 font-bold text-sm shadow-md bg-slate-200 hover:bg-slate-100 hover:shadow-docpgr-purple-glow transition'>
                        cancel
                    </button>
                    <button type='submit' disabled={loading} className='mt-4 px-4 py-2 rounded-lg text-white font-bold text-sm voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow transition'>
                        { loading ? 'onboarding...' : 'onboard' }
                    </button>
                </div>
            </form>
        </Modal>
    )
}